<template>
  <FontAwesomeIcon
    :icon="getSortIcon(sortOrder)"
    class="pv-datatable-sort-icon"
  />
</template>

<script setup lang="ts">
import { getSortIcon } from "@/utils/sortIcons";

/**
 * Sort-state icon for a PrimeVue `Column`'s `#sorticon` slot; pass the slot's `sortOrder` through.
 */
defineProps<{
  sortOrder?: number | null;
}>();
</script>
